module.exports = __webpack_public_path__ + "img/ic24Email.9b7cf555.svg";